


























import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { BuiltInParametersHelper } from '../FormatParametersEditor/BuiltInParametersHelper';


@Component
export default class FormatParametersEditor extends Vue {
  name = 'format-builtin-parameters-editor';
  foundTags: string[] = [];
  @Prop(String) sourcetext: string;

  @Watch("sourcetext")
  findTags() {
    this.foundTags = [];
    if (this.sourcetext) {
      BuiltInParametersHelper.BuiltInParameters.forEach(parameter => {
        if (this.sourcetext.indexOf(parameter) != -1) {
          this.foundTags.push(parameter);
        }
      });
    }
  }

  async created() {
    this.findTags();
  }

}
